import { useEffect, useRef } from "react";

const useSyncPageSize = (filters, setFilters, responsivePageSize) => {
  const prevResponsiveSize = useRef(responsivePageSize);

  useEffect(() => {
    // اگه کاربر خودش مقدار pageSize رو تغییر داده، کاری نکن
    if (
      filters.pageSize !== prevResponsiveSize.current &&
      filters.pageSize !== responsivePageSize
    ) {
      return;
    }

    // فقط وقتی سایز واکنش‌گرا تغییر کرده sync کن
    if (responsivePageSize !== prevResponsiveSize.current) {
      prevResponsiveSize.current = responsivePageSize;
      setFilters((prev) => ({
        ...prev,
        pageSize: responsivePageSize,
        pageNumber: 1, // برگرد به صفحه ۱ در حالت جدید
      }));
    }
  }, [responsivePageSize, setFilters, filters.pageSize]);
};

export default useSyncPageSize;
